<template>
    <div class="container">
        <div class="free-trial" v-if="step == 1">
            <div class="free-trial-header">
                <div class="chatbubble">
                    <p id="typewriter">Welcome student! Fill in your information, try the product for free</p>
                </div>
            </div>
            <form id="create_form" class="w-100" method="POST" encType="multipart/form-data" @submit.prevent="onSubmit">
                <div class="form-group">
                    <label for="field_fullname" class="m-0 text-bold">{{ $t('full_name') }}<span class="text-danger">*</span></label>
                    <input type="text" id="field_fullname" class="ito-input" :class="{ ' has-err': errors.fullname }" name="fullname" :placeholder="$t('enter_your_full_name')" @input="changeEvent" v-model="user.fullname" />
                    <div class="error-message text-start" v-if="errors.fullname">{{ errors.fullname }}</div>
                </div>
                <!-- <div class="form-group">
                    <label for="field_phone" class="m-0 text-bold">{{ $t('phone_name') }}<span class="text-danger">*</span></label>
                    <input type="text" id="field_phone" class="ito-input" :class="{ ' has-err': errors.phone }" name="phone" :placeholder="$t('enter_your_phone_number')" @input="changeEvent" v-model="user.phone" />
                    <div class="error-message text-start" v-if="errors.phone">{{ errors.phone }}</div>
                </div> -->
                <div class="form-group">
                    <label for="field_invitation_code" class="m-0 text-bold">{{ $t('invitation_code') }}</label>
                    <input type="text" id="field_invitation_code" class="ito-input" :class="{ ' has-err': errors.invitation_code }" name="invitation_code" :placeholder="$t('enter_the_invitation_code')" @input="changeEvent"
                        v-model="user.invitation_code" />
                    <div class="error-message text-start" v-if="errors.invitation_code">{{ errors.invitation_code }}</div>
                </div>
                <div class="form-group d-flex justify-content-end gap-3">
                    <router-link class="ito-btn ito-btn-outline-primary" :to="{ name: 'login' }">{{ $t('back') }}</router-link>
                    <button type="submit" class="ito-btn ito-btn-primary" :disabled="!is_validated">{{ $t('next') }}</button>
                </div>
            </form>
        </div>
        <div class="free-trial-box" v-if="step == 2">
            <h3 class="popup-title">Learning <span class="text-primary">English</span> through</h3>
            <h6 class="popup-description"><span class="text-info">Mathematics</span> and <span class="text-info">Science</span></h6>
            <div class="trial-img-title">
                <img src="/images/anomy-img.svg" alt="">
            </div>
            <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
            <h3 class="popup-description mb-20">{{ $t('choose_grade_2') }}</h3>

            <div class="grade-select-body">
                <div class="grade-select-list flex-wrap">
                    <template v-for="grade in grades">
                        <div @click="user.grade = grade" class="grade-select-item" :class="{ active: grade == user.grade }">{{ grade }}
                        </div>
                    </template>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-20 gap-3">
                <button type="button" class="ito-btn ito-btn-outline-primary" @click="step -= 1">
                    {{ $t('back') }}
                </button>
                <button type="button" class="ito-btn ito-btn-primary" @click="onSubmit" :disabled="!user.grade">
                    {{ $t('let_s_go_and_try') }}
                </button>
            </div>
        </div>


    </div>
</template>

<script>
// import Typewriter from 'typewriter-effect';
import Typewriter from 'typewriter-effect/dist/core';
import { authRegisterAnomynous, validateInvitationCode } from '../../models/auth'
import axios from "axios";
import { mapGetters } from 'vuex'
import { getAvatars, getConfig } from "../../models/profile";
import { getConfigs, getLanguage, isNumber, isVietnamesePhoneNumber, regexSpecialChar } from "../../utils/utils";
import { reject } from 'lodash';


export default {
    name: "RegisterAnomynous",
    data() {
        const configs = getConfigs();
        const locate = getLanguage();
        const localizes = configs.localize || [];
        const grades = configs.grades || [];

        let locate_info = {};
        localizes.forEach(item => {
            if (item.lang == locate) {
                locate_info = item;
            }
        });
        return {
            grades: grades.sort(function (a, b) { return a - b }),
            errors: {
                message: false,
                fullname: false,
                phone: false,
                invitation_code: false
            },
            locate: getLanguage(),
            locate_info: locate_info,
            configs: configs,
            localizes: localizes,
            step: 1,
            user: {
                fullname: '',
                // phone: '',
                invitation_code: '',
                campaign_id: '',
                grade: null
            },
            is_validated: false
        };
    },

    mounted() {
        var typewriter = new Typewriter('#typewriter', {
            delay: 50,
        });
        typewriter
            .typeString(this.$i18n.t('register_anomynous_msg'))
            .start();
    },

    methods: {
        onSubmit() {
            switch (this.step) {
                case 1:
                    if (this.user.invitation_code != '') {
                        this.validateInvitationCode();
                    } else {
                        this.step = 2
                    }

                    break;
                case 2:
                    this.login();
                    break;

                default:
                    break;
            }
            return;
        },

        async login() {
            const that = this;
            that.$store.commit("setLoading", true);
            const params = {
                grade: this.user.grade,
                campaign_id: this.user.campaign_id,
                // phone: this.user.phone,
                full_name: this.user.fullname,
            }
            await authRegisterAnomynous(params).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    this.errors.message = response.data.msg;
                    return false;
                }
                that.$store.commit('setAuth', true);
                localStorage.removeItem('checkedSubjects');
                localStorage.setItem('access_token', response.data.results.access_token);
                this.$router.push('home')
            }).catch((error) => {
                this.$store.commit('setAuth', false);
                that.$store.commit("setLoading", false);
                that.errors.message = error;
            });
        },



        validateName() {
            var message = undefined
            if (this.user.fullname == '') {
                message = this.$i18n.t('fullname_cannot_be_empty');
            } else if (regexSpecialChar(this.user.fullname)) {
                message = this.$i18n.t('fullname_cannot_contain_special_characters');
            }
            else {
                this.errors.fullname = false;
                message = undefined
            }
            return message;
        },

        // validatePhone() {
        //     var message = undefined
        //     if (this.user.phone == '') {
        //         message = this.$i18n.t('phone_number_is_not_empty');
        //     } else {
        //         if (isNumber(this.user.phone)) {
        //             if (isVietnamesePhoneNumber(this.user.phone)) {
        //                 this.errors.phone = false;
        //                 message = undefined
        //             } else {
        //                 message = this.$i18n.t('wrong_phone_format');
        //             }
        //         }
        //         else {
        //             message = this.$i18n.t('wrong_phone_format');
        //         }
        //     }
        //     return message;
        // },

        async validateInvitationCode() {
            var invitation_code = this.user.invitation_code
            this.$store.commit("setLoading", true);
            var result = await validateInvitationCode({ invitation_code: invitation_code })
            this.$store.commit("setLoading", false);
            var data = result.data;
            if (data.code != 0) {
                this.errors.invitation_code = this.$i18n.t(data.msg);
            } else {
                this.user.campaign_id = data.results.id;
                this.errors.invitation_code = false
                this.step = 2
            }

        },

        changeEvent(event) {
            const target = event.target
            this.errors[target.name] = false
            var is_valid = '';
            switch (target.name) {
                case 'fullname':
                    this.errors.fullname = this.validateName()
                    break;
                // case 'phone':
                //     this.errors.phone = this.validatePhone()
                //     break;
                default:
                    break;
            }
            if (this.validateName()) {
                is_valid = false
            } else {
                is_valid = true
            }
            this.is_validated = is_valid;
        }
    }

}
</script>

<style scoped>
.form-group {
    position: relative;
}

.ito-input {
    width: 100%;
}

.free-trial-box {
    position: relative;
    width: 658px;
    /* height: 456px; */
    background: #ffffff;
    margin: auto;
    padding: 20px;
    text-align: center;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    border-radius: 8px;
    overflow: hidden;
}

.trial-img-title img {
    width: 110px;
    margin: 15px auto;
}

.free-trial-bottom {
    position: absolute;
    width: 100%;
    margin: auto;
    left: 0;
    bottom: 0;
    padding: 15px;
    background: #3164CC;
}

.free-trial-box a {
    display: block;
    margin: 15px auto;
    cursor: pointer;
    color: #ffffff;
}

.free-trial-box a:hover {
    text-decoration: none;
    color: #ffffff;
}

.free-trial-bottom h4 {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0px;
    color: #ffffff;
}

.select-lang {
    display: block;
    position: absolute;
    bottom: 10px;
    right: 10px;
    padding: 8px;
    background: #ffffff;
    border-radius: 8px;
    cursor: pointer;
}

.free-trial {
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #FFFFFF;
    margin: auto;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, .07), inset 0 4px 0 hsla(0, 0%, 91%, .25);
    border-radius: 16px;
    padding: 30px 40px;

}

.free-trial .free-trial-header {
    width: 262px;
    padding-bottom: 80px;
    background-image: url('/public/themes/ito/images/mascot/hello.svg');
    background-size: 96px 110px;
    background-position: bottom right;
    background-repeat: no-repeat;
}

.free-trial .free-trial-header .chatbubble {
    background-image: url('/public/themes/ito/images/chat-bubble-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    left: 0;
    top: 0;
    padding: 14px 38px 14px 14px;
    width: calc(100% - 60px);
    text-align: center;
    overflow: hidden;
}

.free-trial .free-trial-header .chatbubble p {
    font-size: 14px;
    font-weight: 400;
    line-height: 19.1px;
}
</style>